// eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useState, useEffect } from 'react'
import './ProductoDetalleComplementarios.scss'
import { connect } from 'react-redux';
import { DobleGuion } from './DobleGuion'
import ProductoComplementario from './ProductoComplementario'
import { useActiveDesactiveSrollBody } from '../hooks/activeDesactivScrollBody';
import { setFormatSelected } from '../actions/index'

const ProductoDetalleComplementarios = (props) => {
    const [showProductComplement, setShowProductComplement] = useState(false)
    const [oldStatusFormatSelected, setOldStatusFormatSelected] = useState(false)
    const [productosComplementarios, setProductosComplementarios] = useState([])
    const [productoComplementario, setProductoComplementario] = useState(undefined)


    useEffect(() => {
        let complementarioRef = [];
        if (props.producto.ProductoComplementario.indexOf(', ') > -1) {
            complementarioRef = props.producto.ProductoComplementario.split(', ')
        } else {
            complementarioRef.push(props.producto.ProductoComplementario)
        }
        const productosComplementarios = [];
        for (let i = 0; i < complementarioRef.length; i++) {
            const complementario = complementarioRef[i];
            const productoComplementario = props.allProducts.find(el => {
                return el.RefSuelto === complementario.trim()
            })
            productosComplementarios.push(productoComplementario)
        }
        setProductosComplementarios(productosComplementarios)
    }, [props.producto])


    const handleSelectChage = (producto) => {
        setProductoComplementario(producto)
        setOldStatusFormatSelected(props.formatSelected)
        setShowProductComplement(true)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useActiveDesactiveSrollBody(true)
    }

    const handleCloseProductComplement = () => {
        props.setFormatSelected(oldStatusFormatSelected)
        setShowProductComplement(false)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useActiveDesactiveSrollBody(false)
    }

    return (
        <React.Fragment>
            {
                showProductComplement &&
                <ProductoComplementario product={productoComplementario} clickClose={handleCloseProductComplement} ></ProductoComplementario>
            }
            {
                productosComplementarios.length > 0 &&
                <div className="producto-complementario">
                    <div className="titulo"><p>Producto complementario</p> <DobleGuion /></div>
                    {
                        productosComplementarios.map((producto, index) => {
                            return (
                                <div className="item">
                                    <div className="img">
                                        <img src={"/static/imgProducts/" + producto.Fotografia + "_p.jpg"} onError={(e) => {
                                            e.target.onerror = null
                                            e.target.src = '/static/img/no-imagen-fansa.png'
                                        }} alt="" />
                                    </div>
                                    <div className="text-btn">
                                        <div className="text">{producto.Nombre}</div>
                                        <div className="btn btn-invert" onClick={() => handleSelectChage(producto)}>Ver más</div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            }
        </React.Fragment>
    )
}

const mapDispatchToProps = {
    setFormatSelected
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(ProductoDetalleComplementarios)
